import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useMemo, useState } from 'react'

import Modal from '../../../../common/Modal'
import SubmitButton from '../../../../common/buttons/SubmitButton'
import StudentItem from '../../../../students/StudentItem'

import classes from './AddStudentsWaitlistModal.module.scss'

import { deserialize } from '../../../../../utility/serialization'
import { setIsWaitlistModalOpen } from '../../../../../reducers/programPresentationReducer'

const AddStudentsWaitlistModal = ({ handleAddStudentsToWaitlist }) => {
  const dispatch = useDispatch()
  const course = useSelector(state => state.programPresentation.course)
  const isWaitlistModalOpen = useSelector(state => state.programPresentation.isWaitlistModalOpen)
  const currentUser = useSelector(state => state.user.current_user)

  const [selectedStudents, setSelectedStudents] = useState([]) // IDs only

  const students = useMemo(
    // Not ideal to call deserialize() here; TODO: Change in the future
    () => deserialize(currentUser).family.users.filter(user => user.type === 'Student' && user.isGolfer),
    [currentUser]
  )

  const selectStudent = useCallback(
    (student) => {
      if (selectedStudents.includes(student.id)) {
        setSelectedStudents(students => students.filter(studentId => studentId !== student.id))
      } else {
        setSelectedStudents(students => [...students, student.id])
      }
    },
    [selectedStudents, setSelectedStudents]
  )

  const checkStudentAlreadyJoined = useCallback(
    (student) => course.waitlistedStudents.some(student_ => student_.id === student.id),
    [course]
  )

  const checkStudentAlreadyEnrolled = useCallback(
    (student) => course.familyEnrollments.some(enrollment => enrollment.userId === student.id),
    [course]
  )

  return (
    <Modal className={classes.modal} isOpen={isWaitlistModalOpen} onClose={() => dispatch(setIsWaitlistModalOpen(false))}>
      <div className={classes.content}>
        <h4 className={classes.title}>Join Waitlist</h4>
        <p className={classes.message}>
          Join Waitlist for this program. You will receive an email communication —
          coach can either add you to the program or ask you to join a similar one.
        </p>
        <div className={classes.form}>
          <ul className={classes.students}>
            {students.map(student => (
              <li className={classes.student} key={student.id}>
                <StudentItem
                  student={student}
                  isSelected={selectedStudents.includes(student.id)}
                  onSelect={() => selectStudent(student)}
                  joined={checkStudentAlreadyJoined(student)}
                  enrolled={checkStudentAlreadyEnrolled(student)}
                />
              </li>
            ))}
          </ul>
          <SubmitButton
            onClick={() => handleAddStudentsToWaitlist(selectedStudents)}
            buttonMessage='Join Waitlist'
            buttonColor={!selectedStudents.length ? 'navy-button' : 'orange-button'}
            disabled={!selectedStudents.length}
            noTopMargin
          />
        </div>
      </div>
    </Modal>
  )
}
AddStudentsWaitlistModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  handleAddStudentsToWaitlist: PropTypes.func,
}

export default AddStudentsWaitlistModal
